'use strict'

import Template from './Template.js'

export default {
	getBoards: () => [
		{
			name: 'smoothieboard',
            type: 'LPC',
			caption: 'Smoothieboard',
			motorWarningCurrent: 1200,
			motorLimitCurrent: 2000,
			seriesResistor: 4700,
			microstepping: false,
			microsteppingInterpolation: false,
			numDrives: 5,
			heaterPorts: ['bed', 'e0heat', 'e1heat'],
			fanPorts: ['Q4', 'Q8', 'fan0'],
			pwmPorts: ['Q4', 'bed', 'e0heat', 'e1heat', 'Q8', 'fan0'],
			gpioPorts: ['xstop', 'xstopmax', 'ystop', 'ystopmax', 'zstop', 'zstopmax'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp', 't3'],
            blPorts: [],
			spiCsPorts: [],
			hasEthernet: true,
            hasWiFi: false,
            hasESP: false,
            hasESPUpdate: false,
            hasESPOnboard: false,
            hasSBC: false,
            hasSBCOnboard: false,
			hasPowerFailureDetection: false,
			hasMotorLoadDetection: false,
			supportsDisplay: true,
			supports12864: true, 
			firmwareStandaloneFile: 'firmware-lpc-wifi',
            firmwareSBCFile: 'firmware-lpc-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-lpc',
            firmwareWifi32File: 'N/A',
            requiresBeta: false,
			iapFile: '',
			expansionBoards: [],
			maxExpansionBoards: 0,
            stepperDriver: "A5984",
            stepperDriverTimings: "1.0:1.0:0.4:0.4",
            stepperDriverSmart: false,
            stepperDriver5160: false,
            stepperDriver5160SPI: 'N/A',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'',
            serialTxPin:'',
            espDataReadyPin:'',
            lpcTfrReadyPin:'',
            espResetPin:'',
            lpc: {
                  externalSDCard:{
                      csPin: "0.28",
                      cardDetectPin: "0.27",
                      spiFrequencyHz: 4000000,
                      spiChannel: 0,
                  },
                  internalSDCardSPIFrequencyHz: 25000000,
                  lcd:{
                      lcdCSPin:       "0.16",
                      lcdBeepPin:     "1.31",
                      encoderPinA:    "3.25",
                      encoderPinB:    "3.26",
                      encoderPinSw:   "1.30",
                      lcdDCPin:       "NoPin",
                      panelButtonPin: "2.11",
                      spiChannel: 0,
                  },
                  diagnosticPin: "1.18",
            },
            drives: [
				{
                    diag: "NoPin",
                }
            ],
            auxRX:'',
            auxTX:'',
            serialAmount:'1',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: false,
                espDataReadyPin:'N/A',
                lpcTfrReadyPin:'N/A',
                espResetPin:'N/A',
                wifi8266CSPin: 'N/A'
            },
            neopixel :'NoPin',
            requiresRXTX: true

		},
        {
            name: 'biquskr_1.1',
            type: 'LPC',
            caption: 'SKR v1.1',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: false,
            microsteppingInterpolation: false,
            numDrives: 5,
            heaterPorts: ['bed', 'e0heat', 'e1heat'],
            fanPorts: ['fan0', 'e1heat'],
            pwmPorts: ['bed', 'e0heat', 'e1heat', 'fan0'],
            gpioPorts: ['xstop', 'xstopmax', 'ystop', 'ystopmax', 'zstop', 'zstopmax'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp'],
            blPorts: [],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: false,
            hasESPOnboard: false,
            hasSBC: true,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: false,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-lpc-wifi',
            firmwareSBCFile: 'firmware-lpc-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-lpc',
            firmwareWifi32File: 'N/A',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperDriver: "", // no built in drivers.
            stepperDriverTimings: "",
            stepperDriverSmart: false,
            stepperDriver5160: false,
            stepperDriver5160SPI: 'N/A',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'0.3',
            serialTxPin:'0.2',
            espDataReadyPin:'0.28',
            lpcTfrReadyPin:'1.30',
            espResetPin:'1.31',
            lpc: {
                externalSDCard:{
                    csPin: "1.23",
                    cardDetectPin: "1.31",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["1.20", "NoPin", "1.18"],
                },
                lcd:{
                    lcdCSPin:       "0.16",
                    lcdBeepPin:     "1.30",
                    encoderPinA:    "3.26",
                    encoderPinB:    "3.25",
                    encoderPinSw:   "2.11",
                    lcdDCPin:       "0.18",
                    panelButtonPin: "NoPin",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "NoPin",
            },
            drives: [
                {
                diag: "NoPin",
                }
            ],
            auxRX:'0.3',
            auxTX:'0.2',
            serialAmount:'1',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: false,
                espDataReadyPin:'N/A',
                lpcTfrReadyPin:'N/A',
                espResetPin:'N/A',
                wifi8266CSPin: 'N/A'
            },
            neopixel :'NoPin',
            requiresRXTX: true
        },
        {
            name: 'biquskr_1.3',
            type: 'LPC',
            caption: 'SKR v1.3',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 5,
            heaterPorts: ['bed', 'e0heat', 'e1heat'],
            fanPorts: ['fan0', 'e1heat'],
            pwmPorts: ['bed', 'e0heat', 'e1heat', 'fan0'],
            gpioPorts: ['xstop', 'xstopmax', 'ystop', 'ystopmax', 'zstop', 'zstopmax'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: false,
            hasESPOnboard: false,
            hasSBC: true,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-lpc-wifi',
            firmwareSBCFile: 'firmware-lpc-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-lpc',
            firmwareWifi32File: 'N/A',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: ['BTT EXP-MOT'],
            maxExpansionBoards: 1,
            stepperDriver: "", // no built in drivers.
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: false,
            stepperDriver5160SPI: 'N/A',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'0.3',
            serialTxPin:'0.2',
            espDataReadyPin:'0.28',
            lpcTfrReadyPin:'1.30',
            espResetPin:'1.31',
            lpc: {
                externalSDCard:{
                    csPin: "0.16",
                    cardDetectPin: "1.31",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["1.20", "NoPin", "1.18"],
                },
                lcd:{
                    lcdCSPin:       "1.19",
                    lcdBeepPin:     "1.30",
                    encoderPinA:    "3.26",
                    encoderPinB:    "3.25",
                    encoderPinSw:   "0.28",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "NoPin",
            },
            drives: [
				{
                    diag: "1.29",
                },
                {
                    diag: "1.28",
                },
                {
                    diag: "1.27",
                },
                {
                    diag: "1.26",
                },
                {
                    diag: "1.25",
                }
            ],
            auxRX:'0.3',
            auxTX:'0.2',
            serialAmount:'1',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: false,
                espDataReadyPin:'N/A',
                lpcTfrReadyPin:'N/A',
                espResetPin:'N/A',
                wifi8266CSPin: 'N/A'
            },
            neopixel :'NoPin',
            requiresRXTX: true
        },
	    {
            name: 'biquskr_1.4',
            type: 'LPC',
            caption: 'SKR v1.4',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 5,
            heaterPorts: ['bed', 'e0heat', 'e1heat'],
            fanPorts: ['fan0', 'e1heat'],
            pwmPorts: ['bed', 'e0heat', 'e1heat', 'fan0'],
            gpioPorts: ['xstop', 'ystop', 'zstop', 'e0stop', 'e1stop', 'probe', 'pwrstop'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: false,
            hasESPOnboard: false,
            hasSBC: true,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-lpc-wifi',
            firmwareSBCFile: 'firmware-lpc-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-lpc',
            firmwareWifi32File: 'N/A',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: ['BTT EXP-MOT'],
            maxExpansionBoards: 1,
            stepperDriver: "", // no built in drivers.
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: false,
            stepperDriver5160SPI: 'N/A',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'4.29',
            serialTxPin:'4.28',
            espDataReadyPin:'0.28',
            lpcTfrReadyPin:'1.30',
            espResetPin:'1.31',
            lpc: {
                externalSDCard:{
                    csPin: "0.16",
                    cardDetectPin: "1.31",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["1.20", "NoPin", "1.18"],
                },
                lcd:{
                    lcdCSPin:       "1.19",
                    lcdBeepPin:     "1.30",
                    encoderPinA:    "3.26",
                    encoderPinB:    "3.25",
                    encoderPinSw:   "0.28",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "NoPin",
            },
            drives: [
				{
                    diag: "1.29",
                },
                {
                    diag: "1.28",
                },
                {
                    diag: "1.27",
                },
                {
                    diag: "1.26",
                },
                {
                    diag: "1.25",
                }
            ],
            auxRX:'0.3',
            auxTX:'0.2',
            serialAmount:'2',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: false,
                espDataReadyPin:'N/A',
                lpcTfrReadyPin:'N/A',
                espResetPin:'N/A',
                wifi8266CSPin: 'N/A'
            },
            neopixel :'1.24',
            requiresRXTX: true
        },
	    {
            name: 'azsmz',
            type: 'LPC',
            caption: 'Azsmz Mini',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: false,
            microsteppingInterpolation: false,
            numDrives: 5,
            heaterPorts: ['bed', 'e0heat', 'e1heat'],
            fanPorts: ['fan0', 'e1heat'],
            pwmPorts: ['bed', 'e0heat', 'e1heat', 'fan0'],
            gpioPorts: ['xstop', 'ystop', 'zstop', 'e0stop', 'e1stop', 'probe', 'servo0'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp'],
            blPorts: [],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: false,
            hasESPUpdate: false,
            hasESPOnboard: false,
            hasSBC: false,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: false,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-lpc-wifi',
            firmwareSBCFile: 'firmware-lpc-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-lpc',
            firmwareWifi32File: 'N/A',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperDriver: "", // no built in drivers.
            stepperDriverTimings: "",
            stepperDriverSmart: false,
            stepperDriver5160: false,
            stepperDriver5160SPI: 'N/A',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'0.3',
            serialTxPin:'0.2',
            espDataReadyPin:'0.28',
            lpcTfrReadyPin:'1.30',
            espResetPin:'1.31',
            lpc: {
                externalSDCard:{
                    csPin: "0.16",
                    cardDetectPin: "3.25",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "1.22",
                    lcdBeepPin:     "1.30",
                    encoderPinA:    "4.28",
                    encoderPinB:    "1.27",
                    encoderPinSw:   "3.26",
                    lcdDCPin:       "2.6",
                    panelButtonPin: "NoPin",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "1.18",
            },
            drives: [
				{
                    diag: "NoPin",
                }
            ],
            auxRX:'',
            auxTX:'',
            serialAmount:'1',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: false,
                espDataReadyPin:'N/A',
                lpcTfrReadyPin:'N/A',
                espResetPin:'N/A',
                wifi8266CSPin: 'N/A'
            },
            neopixel :'NoPin',
            requiresRXTX: true
        },
	    {
            name: 'azteegX5_1.1',
            type: 'LPC',
            caption: 'Azteeg X5 Mini v1.1',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: false,
            microsteppingInterpolation: false,
            numDrives: 4,
            heaterPorts: ['bed', 'e0heat', 'e1heat'],
            fanPorts: ['fan0', 'e1heat'],
            pwmPorts: ['bed', 'e0heat', 'e1heat', 'fan0'],
            gpioPorts: ['xstop', 'ystop', 'zstop', 'e0stop'],
            analogPorts: ['bedtemp', 'e0temp'],
            blPorts: [],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: false,
            hasESPUpdate: false,
            hasESPOnboard: false,
            hasSBC: false,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: false,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-lpc-wifi',
            firmwareSBCFile: 'firmware-lpc-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-lpc',
            firmwareWifi32File: 'N/A',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperDriver: "", // no built in drivers.
            stepperDriverTimings: "",
            stepperDriverSmart: false,
            stepperDriver5160: false,
            stepperDriver5160SPI: 'N/A',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'',
            serialTxPin:'',
            espDataReadyPin:'',
            lpcTfrReadyPin:'',
            espResetPin:'',
            lpc: {
                externalSDCard:{
                    csPin: "1.23",
                    cardDetectPin: "1.31",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "0.16",
                    lcdBeepPin:     "0.25",
                    encoderPinA:    "3.25",
                    encoderPinB:    "3.26",
                    encoderPinSw:   "2.11",
                    lcdDCPin:       "2.6",
                    panelButtonPin: "1.22",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "4.28",
            },
            drives: [
				{
                    diag: "NoPin",
                }
            ],
            auxRX:'',
            auxTX:'',
            serialAmount:'1',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: false,
                espDataReadyPin:'N/A',
                lpcTfrReadyPin:'N/A',
                espResetPin:'N/A',
                wifi8266CSPin: 'N/A'
            },
            neopixel :'NoPin',
            requiresRXTX: true
        },
        {
            name: 'rearm',
            type: 'LPC',
            caption: 'ReARM',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: false,
            microsteppingInterpolation: false,
            numDrives: 5,
            heaterPorts: ['bed', 'e0heat', 'e1heat'],
            fanPorts: ['e1heat'],
            pwmPorts: ['bed', 'e0heat', 'e1heat', 'Servo0', 'Servo1', 'Servo3'],
            gpioPorts: ['xstop', 'xstopmax', 'ystop', 'ystopmax', 'zstop', 'zstopmax'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp'],
            blPorts: [],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: false,
            hasESPUpdate: false,
            hasESPOnboard: false,
            hasSBC: false,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: false,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-lpc-wifi',
            firmwareSBCFile: 'firmware-lpc-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-lpc',
            firmwareWifi32File: 'N/A',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperDriver: "", // no built in drivers.
            stepperDriverTimings: "",
            stepperDriverSmart: false,
            stepperDriver5160: false,
            stepperDriver5160SPI: 'N/A',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'',
            serialTxPin:'',
            espDataReadyPin:'',
            lpcTfrReadyPin:'',
            espResetPin:'',
            lpc: {
                externalSDCard:{
                    csPin: "1.23",
                    cardDetectPin: "1.31",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                lcd:{
                    lcdCSPin:       "0.16",
                    lcdBeepPin:     "1.30",
                    encoderPinA:    "3.25",
                    encoderPinB:    "3.26",
                    encoderPinSw:   "2.11",
                    lcdDCPin:       "2.6",
                    panelButtonPin: "1.22",
                    spiChannel: 0,
                },
                diagnosticPin: "4.28",
            },
            drives: [
				{
                    diag: "NoPin",
                }
            ],
            auxRX:'',
            auxTX:'',
            serialAmount:'1',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: false,
                espDataReadyPin:'N/A',
                lpcTfrReadyPin:'N/A',
                espResetPin:'N/A',
                wifi8266CSPin: 'N/A'
            },
            neopixel :'NoPin',
            requiresRXTX: true
        },
        {
            name: 'mkssbase_1.3',
            type: 'LPC',
            caption: 'MKS Sbase 1.3',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: false,
            microsteppingInterpolation: false,
            numDrives: 5,
            heaterPorts: ['BED', 'E1', 'E2'],
            fanPorts: ['FAN', 'E2'],
            pwmPorts: ['BED', 'E1', 'E2', 'FAN'],
            gpioPorts: ['XMin', 'YMin', 'ZMin', 'XMax', 'YMax', 'ZMax'],
            analogPorts: ['TH1', 'TH2', 'TH3', 'TH4'],
            blPorts: [],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: false,
            hasESPUpdate: false,
            hasESPOnboard: false,
            hasSBC: false,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: false,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-lpc-wifi',
            firmwareSBCFile: 'firmware-lpc-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-lpc',
            firmwareWifi32File: 'N/A',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperDriver: "DRV8825",
            stepperDriverTimings: "1.9:1.9:0.65:0.65",
            stepperDriverSmart: false,
            stepperDriver5160: false,
            stepperDriver5160SPI: 'N/A',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'0.3',
            serialTxPin:'0.2',
            espDataReadyPin:'',
            lpcTfrReadyPin:'',
            espResetPin:'',
            lpc: {
                externalSDCard:{
                    csPin: "0.28",
                    cardDetectPin: "0.27",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                    },
                internalSDCardSPIFrequencyHz: 25000000,
                lcd:{
                    lcdCSPin:       "0.16",
                    lcdBeepPin:     "1.31",
                    encoderPinA:    "3.25",
                    encoderPinB:    "3.26",
                    encoderPinSw:   "1.30",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "2.11",
                    spiChannel: 0,
                },
                diagnosticPin: "1.18",
            },
            drives: [
				{
                    diag: "NoPin",
                }
            ],
            auxRX:'0.3',
            auxTX:'0.2',
            serialAmount:'1',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: false,
                espDataReadyPin:'N/A',
                lpcTfrReadyPin:'N/A',
                espResetPin:'N/A',
                wifi8266CSPin: 'N/A'
            },
            neopixel :'NoPin',
            requiresRXTX: true
        },
        {
            name: 'mkssgenl_1.0',
            type: 'LPC',
            caption: 'MKS SGen L v1.0',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 5,
            heaterPorts: ['bed', 'e0heat', 'e1heat'],
            fanPorts: ['fan0', 'e1heat'],
            pwmPorts: ['bed', 'e0heat', 'e1heat', 'fan0'],
            gpioPorts: ['xstop', 'xstopmax', 'ystop', 'ystopmax', 'zstop', 'zstopmax'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: false,
            hasESPOnboard: false,
            hasSBC: true,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-lpc-wifi',
            firmwareSBCFile: 'firmware-lpc-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-lpc',
            firmwareWifi32File: 'N/A',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: false,
            stepperDriver5160SPI: 'N/A',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'0.3',
            serialTxPin:'0.2',
            espDataReadyPin:'0.28',
            lpcTfrReadyPin:'1.30',
            espResetPin:'1.31',
            lpc: {
                externalSDCard:{
                    csPin: "0.16",
                    cardDetectPin: "1.31",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                    },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["1.20", "NoPin", "1.18"],
                    },
                lcd:{
                    lcdCSPin:       "1.19",
                    lcdBeepPin:     "1.30",
                    encoderPinA:    "3.26",
                    encoderPinB:    "3.25",
                    encoderPinSw:   "0.28",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "1.18",
            },
            drives: [
                {
                diag: "1.29",
                },
                {
                diag: "1.27",
                },
                {
                diag: "1.25",
                },
                {
                diag: "1.28",
                },
                {
                diag: "1.26",
                }
            ],
            auxRX:'0.3',
            auxTX:'0.2',
            serialAmount:'1',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: false,
                espDataReadyPin:'N/A',
                lpcTfrReadyPin:'N/A',
                espResetPin:'N/A',
                wifi8266CSPin: 'N/A'
            },
            neopixel :'NoPin',
            requiresRXTX: true
        },
        {
            name: 'mkssgenl_2.0',
            type: 'LPC',
            caption: 'MKS SGen L v2.0',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 5,
            heaterPorts: ['bed', 'e0heat', 'e1heat'],
            fanPorts: ['fan0','fan1', 'e1heat'],
            pwmPorts: ['bed', 'e0heat', 'e1heat', 'fan0','fan1'],
            gpioPorts: ['xstop', 'xstopmax', 'ystop', 'ystopmax', 'zstop', 'zstopmax'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp'],
            blPorts: ['servo0','servo1'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: false,
            hasESPOnboard: false,
            hasSBC: true,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-lpc-wifi',
            firmwareSBCFile: 'firmware-lpc-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-lpc',
            firmwareWifi32File: 'N/A',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: false,
            stepperDriver5160SPI: 'N/A',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'4.29',
            serialTxPin:'4.28',
            espDataReadyPin:'0.28',
            lpcTfrReadyPin:'1.30',
            espResetPin:'1.31',
            lpc: {
                externalSDCard:{
                    csPin: "0.16",
                    cardDetectPin: "1.31",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["1.20", "NoPin", "1.18"],
                },
                lcd:{
                    lcdCSPin:       "1.19",
                    lcdBeepPin:     "1.30",
                    encoderPinA:    "3.26",
                    encoderPinB:    "3.25",
                    encoderPinSw:   "0.28",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "1.18",
            },
            drives: [
                {
                diag: "1.29",
                },
                {
                diag: "1.27",
                },
                {
                diag: "1.25",
                },
                {
                diag: "1.28",
                },
                {
                diag: "1.26",
                }
            ],
            auxRX:'0.3',
            auxTX:'0.2',
            serialAmount:'2',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: false,
                espDataReadyPin:'N/A',
                lpcTfrReadyPin:'N/A',
                espResetPin:'N/A',
                wifi8266CSPin: 'N/A'
            },
            neopixel :'NoPin',
            requiresRXTX: true
        },
        {
            name: 'biquskr_e3t',
            type: 'LPC',
            caption: 'SKR E3 Turbo',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 5,
            heaterPorts: ['bed', 'e0heat', 'e1heat'],
            fanPorts: ['fan0','fan1', 'e1heat'],
            pwmPorts: ['bed', 'e0heat', 'e1heat', 'fan0','fan1'],
            gpioPorts: ['xstop', 'ystop', 'zstop', 'e0stop','e1stop','probe0','probe1','ptdet'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp'],
            blPorts: ['servo0','servo1'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: false,
            hasESPOnboard: false,
            hasSBC: true,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-lpc-wifi',
            firmwareSBCFile: 'firmware-lpc-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-lpc',
            firmwareWifi32File: 'N/A',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: false,
            stepperDriver5160SPI: 'N/A',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'0.3',
            serialTxPin:'0.2',
            espDataReadyPin:'0.19',
            lpcTfrReadyPin:'0.20',
            espResetPin:'2.8',
            lpc: {
                externalSDCard:{
                    csPin: "0.16",
                    cardDetectPin: "1.31",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["1.20", "NoPin", "1.18"],
                },
                lcd:{
                    lcdCSPin:       "1.19",
                    lcdBeepPin:     "1.30",
                    encoderPinA:    "3.26",
                    encoderPinB:    "3.25",
                    encoderPinSw:   "0.28",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "NoPin",
            },
            drives: [
                {
                diag: "1.29",
                },
                {
                diag: "1.28",
                },
                {
                diag: "1.27",
                },
                {
                diag: "1.26",
                },
                {
                diag: "1.25",
                }
            ],
            auxRX:'0.3',
            auxTX:'0.2',
            serialAmount:'1',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: false,
                espDataReadyPin:'N/A',
                lpcTfrReadyPin:'N/A',
                espResetPin:'N/A',
                wifi8266CSPin: 'N/A'
            },
            neopixel :'1.24',
            requiresRXTX: true
        },
        {
            name: 'biquskrpro_1.1',
            requiresBoardTxt: true,
            unknownWifi: true,
            needWifiSerial: true,
            type: 'STM32F4',
            caption: 'SKR Pro',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 6,
            heaterPorts: ['bed', 'e0heat', 'e1heat','e2heat'],
            fanPorts: ['fan0','fan1','fan2'],
            pwmPorts: ['bed', 'e0heat', 'e1heat','e2heat','fan0','fan1','fan2'],
            gpioPorts: ['xstop','ystop','zstop', 'e0stop','e1stop','e2stop','probe'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp','e2temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: false,
            hasESPOnboard: false,
            hasSBC: true,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32f4-wifi',
            firmwareSBCFile: 'firmware-stm32f4-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-stm32',
            firmwareWifi32File: 'DuetWiFiServer-esp32-stm32',
            firmwareNew: 'btt/firmware_skrpro1_1_f4.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: ['BTT EXP-MOT'],
            maxExpansionBoards: 1,
            stepperOnboard: false,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '2',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [
                {
                    diag: "A.15",
                },
                {
                    diag: "B.8",
                },
                {
                    diag: "B.9",

                },
                {
                    diag: "B.3",
                },
                {
                    diag: "G.15",
                },
                {
                    diag: "G.12",
                }
            ],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'A.8',
            lpcTfrReadyPin:'G.4',
            espResetPin:'F.12',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "NoPin",
                    lcdBeepPin:     "NoPin",
                    encoderPinA:    "NoPin",
                    encoderPinB:    "NoPin",
                    encoderPinSw:   "NoPin",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "A.7",
            },
            drives: [
                {
                diag: "B.10",
                stepperDriver: "unknown",
                },
                {
                diag: "E.12",
                stepperDriver: "unknown",
                },
                {
                diag: "G.8",
                stepperDriver: "unknown",
                },
                {
                diag: "E.15",
                stepperDriver: "unknown",
                },
                {
                diag: "E.10",
                stepperDriver: "unknown",
                },
                {
                diag: "G.5",
                stepperDriver: "unknown",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'3',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: true,
                espDataReadyPin:'G.10',
                lpcTfrReadyPin:'F.11',
                espResetPin:'F.12',
                wifi8266CSPin: 'B.12'
            },
            neopixel :'NoPin',
            requiresRXTX: true
        },
        {
            name: 'biquskrpro_1.2',
            requiresBoardTxt: true,
            unknownWifi: true,
            needWifiSerial: true,
            type: 'STM32F4',
            caption: 'SKR Pro',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 6,
            heaterPorts: ['bed', 'e0heat', 'e1heat','e2heat'],
            fanPorts: ['fan0','fan1','fan2'],
            pwmPorts: ['bed', 'e0heat', 'e1heat','e2heat','fan0','fan1','fan2'],
            gpioPorts: ['xstop','ystop','zstop', 'e0stop','e1stop','e2stop','probe'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp','e2temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: false,
            hasESPOnboard: false,
            hasSBC: true,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32f4-wifi',
            firmwareSBCFile: 'firmware-stm32f4-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-stm32',
            firmwareWifi32File: 'DuetWiFiServer-esp32-stm32',
            firmwareNew: 'btt/firmware_skrpro1_2_f4.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: ['BTT EXP-MOT'],
            maxExpansionBoards: 1,
            stepperOnboard: false,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '2',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [
                {
                    diag: "A.15",
                },
                {
                    diag: "B.8",
                },
                {
                    diag: "B.9",
                },
                {
                    diag: "B.3",
                },
                {
                    diag: "G.15",
                },
                {
                    diag: "G.12",
                }
            ],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'A.8',
            lpcTfrReadyPin:'G.4',
            espResetPin:'F.12',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "NoPin",
                    lcdBeepPin:     "NoPin",
                    encoderPinA:    "NoPin",
                    encoderPinB:    "NoPin",
                    encoderPinSw:   "NoPin",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "A.7",
            },
            drives: [
                {
                diag: "B.10",
                stepperDriver: "unknown",
                },
                {
                diag: "E.12",
                stepperDriver: "unknown",
                },
                {
                diag: "G.8",
                stepperDriver: "unknown",
                },
                {
                diag: "E.15",
                stepperDriver: "unknown",
                },
                {
                diag: "E.10",
                stepperDriver: "unknown",
                },
                {
                diag: "G.5",
                stepperDriver: "unknown",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'3',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: true,
                espDataReadyPin:'G.10',
                lpcTfrReadyPin:'F.11',
                espResetPin:'F.12',
                wifi8266CSPin: 'B.12'
            },
            neopixel :'NoPin',
            requiresRXTX: true
        },
        {
            name: 'biqugtr_1.0',
            requiresBoardTxt: true,
            unknownWifi: true,
            needWifiSerial: true,
            type: 'STM32F4',
            caption: 'SKR GTR v1.0',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 6,
            heaterPorts: ['bed', 'e0heat', 'e1heat','e2heat',],
            fanPorts: ['fan0','fan1','fan2'],
            pwmPorts: ['bed', 'e0heat', 'e1heat','e2heat','fan0','fan1','fan2'],
            gpioPorts: ['xstop','ystop','zstop', 'e0stop','e1stop','e2stop','probe'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp','e2temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: false,
            hasESPOnboard: false,
            hasSBC: true,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32f4-wifi',
            firmwareSBCFile: 'firmware-stm32f4-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-stm32',
            firmwareWifi32File: 'DuetWiFiServer-esp32-stm32',
            firmwareNew: 'btt/firmware_gtr1_0_f4.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: ['M5'],
            maxExpansionBoards: 1,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '5',
            stepperDriver5160Pins: '{B.3, B.6, G.15}',
            stepperDriver5160CS: [],
            serialRxPin:'C.7',
            serialTxPin:'C.6',
            espDataReadyPin:'A.15',
            lpcTfrReadyPin:'C.11',
            espResetPin:'B.10',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "NoPin",
                    lcdBeepPin:     "NoPin",
                    encoderPinA:    "NoPin",
                    encoderPinB:    "NoPin",
                    encoderPinSw:   "NoPin",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "A.0",
            },
            drives: [
                {
                diag: "F.2",
                },
                {
                diag: "C.13",
                },
                {
                diag: "E.0",
                },
                {
                diag: "G.14",
                },
                {
                diag: "G.9",
                },
                {
                diag: "D.3",
                },
                {
                diag: "I.4",
                },
                {
                diag: "F.4",
                },
                {
                diag: "F.6",
                },
                {
                diag: "I.7",
                },
                {
                diag: "F.12",
                }
            ],
            auxRX:'D.9',
            auxTX:'D.8',
            serialAmount:'3',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: true,
                espDataReadyPin:'D.10',
                lpcTfrReadyPin:'H.10',
                espResetPin:'B.10',
                wifi8266CSPin: 'B.12'
            },
            neopixel :'F.13',
            requiresRXTX: true
        },
        {
            name: 'fly_cdy',
            type: 'LPC',
            caption: 'Fly-CDY',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 6,
            heaterPorts: ['bed', 'e0heat', 'e1heat','e2heat'],
            fanPorts: ['fan0','fan1','fan2'],
            pwmPorts: ['bed', 'e0heat', 'e1heat','e2heat','fan0','fan1','fan2'],
            gpioPorts: ['xstop','ystop','zstop', 'xstopmax','ystopmax','zstopmax'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp','e2temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: true,
            hasESPOnboard: true,
            hasSBC: false,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-lpc-wifi',
            firmwareSBCFile: 'firmware-lpc-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-lpc',
            firmwareWifi32File: 'N/A',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: false,
            stepperDriver5160SPI: 'N/A',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'0.1',
            serialTxPin:'0.0',
            espDataReadyPin:'0.28',
            lpcTfrReadyPin:'2.7',
            espResetPin:'2.6',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "NoPin",
                    lcdBeepPin:     "NoPin",
                    encoderPinA:    "NoPin",
                    encoderPinB:    "NoPin",
                    encoderPinSw:   "NoPin",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "NoPin",
            },
            drives: [
                {
                diag: "1.29",
                },
                {
                diag: "1.28",
                },
                {
                diag: "1.27",
                },
                {
                diag: "1.25",
                },
                {
                diag: "1.22",
                },
                {
                diag: "1.19",
                }
            ],
            auxRX:'0.3',
            auxTX:'0.2',
            serialAmount:'2',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: false,
                espDataReadyPin:'N/A',
                lpcTfrReadyPin:'N/A',
                espResetPin:'N/A',
                wifi8266CSPin: 'N/A'
            },
            neopixel :'NoPin',
            requiresRXTX: true
        },
        {
            name: 'fly_F407ZG',
            requiresBoardTxt: true,
            unknownWifi: true,
            needWifiSerial: true,
            type: 'STM32F4',
            caption: 'Fly-F407ZG',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 9,
            heaterPorts: ['bed', 'e0heat', 'e1heat','e2heat','e3heat','e4heat','e5heat'],
            fanPorts: ['fan0','fan1','fan2','fan3','fan4','fan5'],
            pwmPorts: ['bed', 'e0heat', 'e1heat','e2heat','e3heat','e4heat','e5heat','fan0','fan1','fan2','fan3','fan4','fan5'],
            gpioPorts: ['xstop','ystop','zstop', 'xstopmax','ystopmax','zstopmax','Z3','DLJC'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp','e2temp','e3temp','e4temp','e5temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: false,
            hasESPOnboard: false,
            hasSBC: true,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: false,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32f4-wifi',
            firmwareSBCFile: 'firmware-stm32f4-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-stm32',
            firmwareWifi32File: 'DuetWiFiServer-esp32-stm32',
            firmwareNew: 'fly/firmware_f407zg_f4.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperOnboard: false,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: false,
            stepperDriver5160SPI: 'N/A',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'A.10',
            serialTxPin:'A.9',
            espDataReadyPin:'E.15',
            lpcTfrReadyPin:'B.10',
            espResetPin:'B.2',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "NoPin",
                    lcdBeepPin:     "NoPin",
                    encoderPinA:    "NoPin",
                    encoderPinB:    "NoPin",
                    encoderPinSw:   "NoPin",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "NoPin",
            },
            drives: [
                {
                diag: "NoPin",
                stepperDriver: "unknown",
                },
                {
                diag: "NoPin",
                stepperDriver: "unknown",
                },
                {
                diag: "NoPin",
                stepperDriver: "unknown",
                },
                {
                diag: "NoPin",
                stepperDriver: "unknown",
                },
                {
                diag: "NoPin",
                stepperDriver: "unknown",
                },
                {
                diag: "NoPin",
                stepperDriver: "unknown",
                },
                {
                diag: "NoPin",
                stepperDriver: "unknown",
                },
                {
                diag: "NoPin",
                stepperDriver: "unknown",
                },
                {
                diag: "NoPin",
                stepperDriver: "unknown",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'1',
            wifi8266CSPin: 'F.11',
            esp32: {
                esp32Supported: true,
                espDataReadyPin:'C.5',
                lpcTfrReadyPin:'C.4',
                espResetPin:'B.2',
                wifi8266CSPin: 'F.11'
            },
            neopixel :'NoPin',
            requiresRXTX: true
        },
        {
            name: 'fly_E3',
            requiresBoardTxt: true,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32F4',
            caption: 'Fly-E3',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 4,
            heaterPorts: ['bed', 'e0heat'],
            fanPorts: ['fan0','fan1'],
            pwmPorts: ['bed', 'e0heat','fan0','fan1'],
            gpioPorts: ['xstop','ystop','zstop', 'probe'],
            analogPorts: ['bedtemp', 'e0temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: true,
            hasESPOnboard: true,
            hasSBC: false,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32f4-wifi',
            firmwareSBCFile: 'firmware-stm32f4-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-stm32',
            firmwareWifi32File: 'N/A',
            firmwareNew: 'fly/firmware_e3_f4.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperOnboard: false,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '5',
            stepperDriver5160Pins: '{D.6, D.4, D.5}',
            stepperDriver5160CS: [],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'E.13',
            lpcTfrReadyPin:'E.14',
            espResetPin:'E.15',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "NoPin",
                    lcdBeepPin:     "NoPin",
                    encoderPinA:    "NoPin",
                    encoderPinB:    "NoPin",
                    encoderPinSw:   "NoPin",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "A.8",
            },
            drives: [
                {
                    diag: "A.2",
                    stepperDriver: "unknown",
                },
                {
                    diag: "A.1",
                    stepperDriver: "unknown",
                },
                {
                    diag: "C.5",
                    stepperDriver: "unknown",
                },
                {
                    diag: "",
                    stepperDriver: "unknown",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'2',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: false,
                espDataReadyPin:'N/A',
                lpcTfrReadyPin:'N/A',
                espResetPin:'N/A',
                wifi8266CSPin: 'N/A'
            },
            neopixel :'NoPin',
            requiresRXTX: true
        },
        {
            name: 'fly_cdyv2',
            requiresBoardTxt: true,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32F4',
            caption: 'Fly-CDYv2',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 6,
            heaterPorts: ['bed', 'e0heat', 'e1heat', 'e2heat'],
            fanPorts: ['fan0','fan1','fan2','laser'],
            pwmPorts: ['bed', 'e0heat', 'e1heat', 'e2heat','fan0','fan1','fan2','laser'],
            gpioPorts: ['xstop','xstopmax','ystop',,'ystopmax','zstop','zstopmax', 'probe'],
            analogPorts: ['bedtemp', 'e0temp','e1temp','e2temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: true,
            hasESPOnboard: true,
            hasSBC: false,
            hasSBCOnboard: false,
            hasPowerFailureDetection: true,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32f4-wifi',
            firmwareSBCFile: 'firmware-stm32f4-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-stm32',
            firmwareWifi32File: 'N/A',
            firmwareNew: 'fly/firmware_cdy2_f4.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperOnboard: false,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '2',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'E.10',
            lpcTfrReadyPin:'E.12',
            espResetPin:'E.11',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "NoPin",
                    lcdBeepPin:     "NoPin",
                    encoderPinA:    "NoPin",
                    encoderPinB:    "NoPin",
                    encoderPinSw:   "NoPin",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "NoPin",
            },
            drives: [
                {
                    diag: "C.7",
                    stepperDriver: "unknown",
                },
                {
                    diag: "C.6",
                    stepperDriver: "unknown",
                },
                {
                    diag: "D.11",
                    stepperDriver: "unknown",
                },
                {
                    diag: "D.10",
                    stepperDriver: "unknown",
                },
                {
                    diag: "B.10",
                    stepperDriver: "unknown",
                },
                {
                    diag: "B.11",
                    stepperDriver: "unknown",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'2',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: false,
                espDataReadyPin:'N/A',
                lpcTfrReadyPin:'N/A',
                espResetPin:'N/A',
                wifi8266CSPin: 'N/A'
            },
            neopixel :'D.15',
            requiresRXTX: true
        },
        {
            name: 'biquskr_rrf_e3_1.1',
            requiresBoardTxt: false,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32F4',
            caption: 'SKR-RFF-E3-v1.1',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 4,
            heaterPorts: ['bed', 'e0heat'],
            fanPorts: ['fan0','fan1'],
            pwmPorts: ['bed', 'e0heat','fan0','fan1','neopixel'],
            gpioPorts: ['xstop','ystop','zstop','probe','pson','e0stop','pwrdet'],
            analogPorts: ['bedtemp', 'e0temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: true,
            hasESPOnboard: true,
            hasSBC: false,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32f4-wifi',
            firmwareSBCFile: 'firmware-stm32f4-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-stm32',
            firmwareWifi32File: 'N/A',
            firmwareNew: 'fly/firmware_skrrrfe3_1_1_f4.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: ['BTT E3 RRF IDEX'],
            maxExpansionBoards: 1,
            stepperOnboard: true,
            stepperDriver: "TMC2209",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: false,
            stepperDriver5160SPI: 'N/A',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'A.6',
            lpcTfrReadyPin:'A.7',
            espResetPin:'A.4',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "NoPin",
                    lcdBeepPin:     "NoPin",
                    encoderPinA:    "NoPin",
                    encoderPinB:    "NoPin",
                    encoderPinSw:   "NoPin",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "E.2",
            },
            drives: [
                {
                    diag: "C.0",
                    stepperDriver: "TMC2209",
                },
                {
                    diag: "C.1",
                    stepperDriver: "TMC2209",
                },
                {
                    diag: "C.2",
                    stepperDriver: "TMC2209",
                },
                {
                    diag: "C.3",
                    stepperDriver: "TMC2209",
                },
                {
                    diag: "B.11",
                    stepperDriver: "TMC2209",
                },
                {
                    diag: "B.10",
                    stepperDriver: "TMC2209",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'2',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: false,
                espDataReadyPin:'N/A',
                lpcTfrReadyPin:'N/A',
                espResetPin:'N/A',
                wifi8266CSPin: 'N/A'
            },
            neopixel :'B.7',
            requiresRXTX: true
        },
        {
            name: 'fly_e3_pro',
            requiresBoardTxt: false,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32F4',
            caption: 'Fly-E3-Pro',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 5,
            heaterPorts: ['bed', 'e0heat', 'e1heat'],
            fanPorts: ['fan0','fan1', 'fan2', 'fan3'],
            pwmPorts: ['bed', 'e0heat', 'e1heat','fan0','fan1', 'fan2', 'fan3','neopixel', 'laser'],
            gpioPorts: ['xstop','ystop','zstop','probe','pson','e0stop', 'e1stop','pwrdet'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp', 'boardtemp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: true,
            hasESPOnboard: true,
            hasSBC: false,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32f4-wifi',
            firmwareSBCFile: 'firmware-stm32f4-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-stm32',
            firmwareNew: 'fly/firmware_e3pro_f4.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            firmwareWifi32File: 'N/A',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperOnboard: true,
            stepperDriver: "TMC2209",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: false,
            stepperDriver5160SPI: 'N/A',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'E.13',
            lpcTfrReadyPin:'E.14',
            espResetPin:'E.15',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "NoPin",
                    lcdBeepPin:     "NoPin",
                    encoderPinA:    "NoPin",
                    encoderPinB:    "NoPin",
                    encoderPinSw:   "NoPin",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "A.8",
            },
            drives: [
                {
                    diag: "A.2",
                    stepperDriver: "TMC2209",
                },
                {
                    diag: "B.10",
                    stepperDriver: "TMC2209",
                },
                {
                    diag: "C.4",
                    stepperDriver: "TMC2209",
                },
                {
                    diag: "D.0",
                    stepperDriver: "TMC2209",
                },
                {
                    diag: "D.1",
                    stepperDriver: "TMC2209",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'2',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: false,
                espDataReadyPin:'N/A',
                lpcTfrReadyPin:'N/A',
                espResetPin:'N/A',
                wifi8266CSPin: 'NoPin'
            },
            neopixel :'B.11',
            requiresRXTX: true
        },
        {
            name: 'biquskr_2',
            requiresBoardTxt: true,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32F4',
            caption: 'BTT SKR 2',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 5,
            heaterPorts: ['bed', 'e0heat', 'e1heat'],
            fanPorts: ['fan0','fan1', 'fan2'],
            pwmPorts: ['bed', 'e0heat', 'e1heat','fan0','fan1', 'fan2','neopixel'],
            gpioPorts: ['xstop','ystop','zstop','probe','pson','e0stop', 'e1stop','pwrdet'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: true,
            hasESPOnboard: false,
            hasSBC: true,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32f4-wifi',
            firmwareSBCFile: 'firmware-stm32f4-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-stm32',
            firmwareWifi32File: 'DuetWiFiServer-esp32-stm32',
            firmwareNew: 'btt/firmware_skr2_f4.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: ['BTT EXP-MOT'],
            maxExpansionBoards: 1,
            stepperOnboard: false,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '3',
            stepperDriver5160Pins: '{ E.15, A.14, E.14 }',
            stepperDriver5160CS: [],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'B.10',
            lpcTfrReadyPin:'B.11',
            espResetPin:'C.14',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "E.9",
                    lcdBeepPin:     "C.5",
                    encoderPinA:    "E.7",
                    encoderPinB:    "B.2",
                    encoderPinSw:   "B.1",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 4, //Software SPI
                },
                diagnosticPin: "A.13",
            },
            drives: [
                {
                    diag: "C.1",
                    stepperDriver: "unknown",
                },
                {
                    diag: "C.3",
                    stepperDriver: "unknown",
                },
                {
                    diag: "C.0",
                    stepperDriver: "unknown",
                },
                {
                    diag: "C.2",
                    stepperDriver: "unknown",
                },
                {
                    diag: "A.0",
                    stepperDriver: "unknown",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'2',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: true,
                espDataReadyPin:'B.10',
                lpcTfrReadyPin:'B.11',
                espResetPin:'C.14',
                wifi8266CSPin: 'NoPin'
            },
            neopixel :'E.6',
            requiresRXTX: true
        },
        {
            name: 'fly_super8',
            requiresBoardTxt: true,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32F4',
            caption: 'Fly Super8',
            motorWarningCurrent: 1800,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 8,
            heaterPorts: ['bed', 'heat0','heat1','heat2','heat3','heat4'],
            fanPorts: ['fan0','fan1', 'fan2','fan3','fan4','fan5','fan6','fan7','fan8','fan9'],
            pwmPorts: ['bed', 'heat0','heat1','heat2','heat3','heat4','fan0','fan1', 'fan2','fan3','fan4','fan5','fan6','fan7','fan8','fan9'],
            gpioPorts: ['io0','io1','io2','io3','io4','io5','io6','io7','hvin','probe'],
            analogPorts: ['ADC_0','ADC_1','ADC_2','ADC_3','ADC_4','ADC_5'],
            blPorts: ['servo'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: true,
            hasESPOnboard: false,
            hasESP32Onboard: true,
            hasSBC: false,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32f4-wifi',
            firmwareSBCFile: 'firmware-stm32f4-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp32-stm32',
            firmwareWifi32File: 'DuetWiFiServer-esp32-stm32',
            firmwareNew: 'fly/firmware_super8_f4.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperOnboard: false,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '2',
            stepperDriver5160Pins: '',
            stepperDriver5160CS: [],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'D.13',
            lpcTfrReadyPin:'D.11',
            espResetPin:'D.10',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "E.9",
                    lcdBeepPin:     "C.5",
                    encoderPinA:    "E.7",
                    encoderPinB:    "B.2",
                    encoderPinSw:   "B.1",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 4, //Software SPI
                },
                diagnosticPin: "NoPin",
            },
            drives: [
                {
                    diag: "G.12",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.11",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.10",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.9",
                    stepperDriver: "unknown",
                },
                {
                    diag: "D.7",
                    stepperDriver: "unknown",
                },
                {
                    diag: "D.6",
                    stepperDriver: "unknown",
                },
                {
                    diag: "A.8",
                    stepperDriver: "unknown",
                },
                {
                    diag: "F.8",
                    stepperDriver: "unknown",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'2',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: true,
                espDataReadyPin:'D.13',
                lpcTfrReadyPin:'D.11',
                espResetPin:'D.10',
                wifi8266CSPin: 'NoPin'
            },
            neopixel :'NoPin',
            requiresRXTX: true
        },
        {
            name: 'fly_cdyv3',
            requiresBoardTxt: true,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32F4',
            caption: 'Fly-CDYv3',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 6,
            heaterPorts: ['bed', 'e0heat', 'e1heat', 'e2heat'],
            fanPorts: ['fan0','fan1','fan2','laser'],
            pwmPorts: ['bed', 'e0heat', 'e1heat', 'e2heat','fan0','fan1','fan2','laser'],
            gpioPorts: ['xstop','xstopmax','ystop',,'ystopmax','zstop','zstopmax', 'probe'],
            analogPorts: ['bedtemp', 'e0temp','e1temp','e2temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: true,
            hasESPOnboard: false,
            hasESP32Onboard: true,
            hasSBC: false,
            hasSBCOnboard: false,
            hasPowerFailureDetection: true,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32f4-wifi',
            firmwareSBCFile: 'firmware-stm32f4-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp32-stm32',
            firmwareWifi32File: 'N/A',
            firmwareNew: 'fly/firmware_cdy3_f4.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperOnboard: false,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '2',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'E.10',
            lpcTfrReadyPin:'E.12',
            espResetPin:'E.11',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "NoPin",
                    lcdBeepPin:     "NoPin",
                    encoderPinA:    "NoPin",
                    encoderPinB:    "NoPin",
                    encoderPinSw:   "NoPin",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "NoPin",
            },
            drives: [
                {
                    diag: "C.7",
                    stepperDriver: "unknown",
                },
                {
                    diag: "C.6",
                    stepperDriver: "unknown",
                },
                {
                    diag: "D.11",
                    stepperDriver: "unknown",
                },
                {
                    diag: "D.10",
                    stepperDriver: "unknown",
                },
                {
                    diag: "B.10",
                    stepperDriver: "unknown",
                },
                {
                    diag: "B.11",
                    stepperDriver: "unknown",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'2',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: true,
                espDataReadyPin:'E.10',
                lpcTfrReadyPin:'E.12',
                espResetPin:'E.11',
                wifi8266CSPin: 'NoPin'
            },
            neopixel :'D.15',
            requiresRXTX: true
        },
        {
            name: 'fly_e3_prov3',
            requiresBoardTxt: false,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32F4',
            caption: 'Fly-E3-Pro-v3',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 2200,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 5,
            heaterPorts: ['bed', 'e0heat', 'e1heat'],
            fanPorts: ['fan0','fan1', 'fan2', 'fan3'],
            pwmPorts: ['bed', 'e0heat', 'e1heat','fan0','fan1', 'fan2', 'fan3','neopixel', 'laser'],
            gpioPorts: ['xstop','ystop','zstop','probe','pson','e0stop', 'e1stop','pwrdet'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp', 'boardtemp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: true,
            hasESPOnboard: false,
            hasESP32Onboard: true,
            hasSBC: false,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32f4-wifi',
            firmwareSBCFile: 'firmware-stm32f4-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp32-stm32',
            firmwareWifi32File: 'N/A',
            firmwareNew: 'fly/firmware_e3pro3_f4.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperOnboard: true,
            stepperDriver: "TMC2209",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: false,
            stepperDriver5160SPI: 'N/A',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'E.13',
            lpcTfrReadyPin:'E.14',
            espResetPin:'E.15',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "NoPin",
                    lcdBeepPin:     "NoPin",
                    encoderPinA:    "NoPin",
                    encoderPinB:    "NoPin",
                    encoderPinSw:   "NoPin",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "NoPin",
            },
            drives: [
                {
                    diag: "A.2",
                    stepperDriver: "TMC2209",
                },
                {
                    diag: "B.10",
                    stepperDriver: "TMC2209",
                },
                {
                    diag: "C.4",
                    stepperDriver: "TMC2209",
                },
                {
                    diag: "D.0",
                    stepperDriver: "TMC2209",
                },
                {
                    diag: "D.1",
                    stepperDriver: "TMC2209",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'2',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: true,
                espDataReadyPin:'E.13',
                lpcTfrReadyPin:'E.14',
                espResetPin:'E.15',
                wifi8266CSPin: 'NoPin'
            },
            neopixel :'B.11',
            requiresRXTX: true
        },
        {
            name: 'biqoctopus_1.1',
            requiresBoardTxt: true,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32F4',
            caption: 'BTT Octopus v1.1 F429',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 5,
            heaterPorts: ['bed', 'e0heat', 'e1heat', 'e2heat', 'e3heat'],
            fanPorts: ['fan0','fan1', 'fan2', 'fan3', 'fan4', 'fan5'],
            pwmPorts: ['bed', 'e0heat', 'e1heat', 'e2heat', 'e3heat','fan0','fan1', 'fan2', 'fan3', 'fan4', 'fan5','neopixel'],
            gpioPorts: ['xstop','ystop','zstop','e0stop','e1stop','e2stop','e3stop','e4stop','probe','pson','pwrdet'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp','e2temp','e3temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: true,
            hasESPOnboard: false,
            hasSBC: true,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32f4-wifi',
            firmwareSBCFile: 'firmware-stm32f4-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-stm32',
            firmwareWifi32File: 'DuetWiFiServer-esp32-stm32',
            firmwareNew: 'btt/firmware_octopus1_1_f4.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 1,
            stepperOnboard: false,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '0',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'D.7',
            lpcTfrReadyPin:'D.10',
            espResetPin:'G.7',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "E.9",
                    lcdBeepPin:     "C.5",
                    encoderPinA:    "E.7",
                    encoderPinB:    "B.2",
                    encoderPinSw:   "B.1",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 4, //Software SPI
                },
                diagnosticPin: "A.13",
            },
            drives: [
                {
                    diag: "G.6",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.9",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.10",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.11",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.12",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.13",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.14",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.15",
                    stepperDriver: "unknown",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'2',
            wifi8266CSPin: 'B.12',
            esp32: {
                esp32Supported: true,
                espDataReadyPin:'D.7',
                lpcTfrReadyPin:'D.10',
                espResetPin:'G.7',
                wifi8266CSPin: 'B.12'
            },
            neopixel :'B.0',
            requiresRXTX: true
        },
        {
            name: 'biqoctopuspro_1.0',
            requiresBoardTxt: true,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32F4',
            caption: 'BTT Octopus Pro v1.0 F429',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 5,
            heaterPorts: ['bed', 'e0heat', 'e1heat', 'e2heat', 'e3heat'],
            fanPorts: ['fan0','fan1', 'fan2', 'fan3', 'fan4', 'fan5'],
            pwmPorts: ['bed', 'e0heat', 'e1heat', 'e2heat', 'e3heat','fan0','fan1', 'fan2', 'fan3', 'fan4', 'fan5','neopixel'],
            gpioPorts: ['xstop','ystop','zstop','e0stop','e1stop','e2stop','e3stop','e4stop','probe','probe1','pson','pwrdet'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp','e2temp','e3temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: true,
            hasESPOnboard: false,
            hasSBC: true,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32f4-wifi',
            firmwareSBCFile: 'firmware-stm32f4-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-stm32',
            firmwareWifi32File: 'DuetWiFiServer-esp32-stm32',
            firmwareNew: 'btt/firmware_octopuspro1_0_f4.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 1,
            stepperOnboard: false,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '0',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'D.7',
            lpcTfrReadyPin:'D.10',
            espResetPin:'G.7',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "E.9",
                    lcdBeepPin:     "C.5",
                    encoderPinA:    "E.7",
                    encoderPinB:    "B.2",
                    encoderPinSw:   "B.1",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 4, //Software SPI
                },
                diagnosticPin: "A.13",
            },
            drives: [
                {
                    diag: "G.6",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.9",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.10",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.11",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.12",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.13",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.14",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.15",
                    stepperDriver: "unknown",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'2',
            wifi8266CSPin: 'B.12',
            esp32: {
                esp32Supported: true,
                espDataReadyPin:'D.7',
                lpcTfrReadyPin:'D.10',
                espResetPin:'G.7',
                wifi8266CSPin: 'B.12'
            },
            neopixel :'B.0',
            requiresRXTX: true
        },
        {
            name: 'fly_gemini',
            requiresBoardTxt: true,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32F4',
            caption: 'Fly-Gemini',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 4,
            heaterPorts: ['bed', 'e0heat'],
            fanPorts: ['fan0'],
            pwmPorts: ['bed', 'e0heat','fan0'],
            gpioPorts: ['xstop','ystop','zstop','probe'],
            analogPorts: ['bedtemp', 'e0temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: false,
            hasESPUpdate: false,
            hasESPOnboard: false,
            hasSBC: true,
            hasSBCOnboard: true,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32f4-wifi',
            firmwareSBCFile: 'firmware-stm32f4-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-stm32',
            firmwareWifi32File: 'DuetWiFiServer-esp32-stm32',
            firmwareNew: 'fly/firmware_gemini1_0_f4.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 1,
            stepperOnboard: false,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '0',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'D.7',
            lpcTfrReadyPin:'D.10',
            espResetPin:'B.3',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "E.9",
                    lcdBeepPin:     "C.5",
                    encoderPinA:    "E.7",
                    encoderPinB:    "B.2",
                    encoderPinSw:   "B.1",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 4, //Software SPI
                },
                diagnosticPin: "A.13",
            },
            drives: [
                {
                    diag: "A.3",
                    stepperDriver: "unknown",
                },
                {
                    diag: "B.1",
                    stepperDriver: "unknown",
                },
                {
                    diag: "B.10",
                    stepperDriver: "unknown",
                },
                {
                    stepperDriver: "unknown",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'2',
            wifi8266CSPin: 'B.12',
            esp32: {
                esp32Supported: false,
                espDataReadyPin:'D.7',
                lpcTfrReadyPin:'D.10',
                espResetPin:'G.7',
                wifi8266CSPin: 'B.12'
            },
            neopixel :'B.0',
            requiresRXTX: true
        },
        {
            name: 'fly_geminiv1.1',
            requiresBoardTxt: false,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32F4',
            caption: 'Fly-Gemini-V1.1',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 4,
            heaterPorts: ['bed', 'e0heat'],
            fanPorts: ['fan0','fan1'],
            pwmPorts: ['bed', 'e0heat','fan0'],
            gpioPorts: ['xstop','ystop','zstop','probe'],
            analogPorts: ['bedtemp', 'e0temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: false,
            hasESPUpdate: false,
            hasESPOnboard: false,
            hasSBC: true,
            hasSBCOnboard: true,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32f4-wifi',
            firmwareSBCFile: 'firmware-stm32f4-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-stm32',
            firmwareWifi32File: 'DuetWiFiServer-esp32-stm32',
            firmwareNew: 'fly/firmware_gemini1_1_f4.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 1,
            stepperOnboard: false,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '0',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'D.7',
            lpcTfrReadyPin:'D.10',
            espResetPin:'C.9',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "E.9",
                    lcdBeepPin:     "C.5",
                    encoderPinA:    "E.7",
                    encoderPinB:    "B.2",
                    encoderPinSw:   "B.1",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 4, //Software SPI
                },
                diagnosticPin: "A.13",
            },
            drives: [
                {
                    diag: "A.3",
                    stepperDriver: "unknown",
                },
                {
                    diag: "B.1",
                    stepperDriver: "unknown",
                },
                {
                    diag: "B.10",
                    stepperDriver: "unknown",
                },
                {
                    stepperDriver: "unknown",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'2',
            wifi8266CSPin: 'B.12',
            esp32: {
                esp32Supported: false,
                espDataReadyPin:'D.7',
                lpcTfrReadyPin:'D.10',
                espResetPin:'G.7',
                wifi8266CSPin: 'B.12'
            },
            neopixel :'B.0',
            requiresRXTX: true
        },
        {
            name: 'fly_geminiv2.0',
            requiresBoardTxt: false,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32F4',
            caption: 'Fly-Gemini-V2.0',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 4,
            heaterPorts: ['bed', 'e0heat'],
            fanPorts: ['fan0','fan1'],
            pwmPorts: ['bed', 'e0heat','fan0'],
            gpioPorts: ['xstop','ystop','zstop','probe'],
            analogPorts: ['bedtemp', 'e0temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: false,
            hasESPUpdate: false,
            hasESPOnboard: false,
            hasSBC: true,
            hasSBCOnboard: true,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32f4-wifi',
            firmwareSBCFile: 'firmware-stm32f4-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-stm32',
            firmwareWifi32File: 'DuetWiFiServer-esp32-stm32',
            firmwareNew: 'fly/firmware_gemini2_0_f4.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 1,
            stepperOnboard: false,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '0',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'D.7',
            lpcTfrReadyPin:'D.10',
            espResetPin:'C.9',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "E.9",
                    lcdBeepPin:     "C.5",
                    encoderPinA:    "E.7",
                    encoderPinB:    "B.2",
                    encoderPinSw:   "B.1",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 4, //Software SPI
                },
                diagnosticPin: "A.13",
            },
            drives: [
                {
                    diag: "A.3",
                    stepperDriver: "unknown",
                },
                {
                    diag: "B.1",
                    stepperDriver: "unknown",
                },
                {
                    diag: "B.10",
                    stepperDriver: "unknown",
                },
                {
                    stepperDriver: "unknown",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'2',
            wifi8266CSPin: 'B.12',
            esp32: {
                esp32Supported: false,
                espDataReadyPin:'D.7',
                lpcTfrReadyPin:'D.10',
                espResetPin:'G.7',
                wifi8266CSPin: 'B.12'
            },
            neopixel :'B.0',
            requiresRXTX: true
        },
        {
            name: 'biquskr_3',
            requiresBoardTxt: true,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32H7',
            caption: 'BTT SKR3 H743',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 5,
            heaterPorts: ['bed', 'e0heat', 'e1heat'],
            fanPorts: ['fan0','fan1', 'fan2'],
            pwmPorts: ['bed', 'e0heat', 'e1heat','fan0','fan1', 'fan2','neopixel'],
            gpioPorts: ['xstop','ystop','zstop','probe','pson','e0stop', 'e1stop','pwrdet'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: true,
            hasESPOnboard: false,
            hasSBC: true,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32h7-wifi',
            firmwareSBCFile: '',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-stm32',
            firmwareWifi32File: 'DuetWiFiServer-esp32-stm32',
            firmwareNew: 'btt/firmware_skr3_h743.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperOnboard: false,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '3',
            stepperDriver5160Pins: '{ E.14, E.15, E.13 }',
            stepperDriver5160CS: [],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'B.10',
            lpcTfrReadyPin:'B.11',
            espResetPin:'C.14',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "E.9",
                    lcdBeepPin:     "C.5",
                    encoderPinA:    "E.7",
                    encoderPinB:    "B.2",
                    encoderPinSw:   "B.1",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 4, //Software SPI
                },
                diagnosticPin: "A.13",
            },
            drives: [
                {
                    diag: "C.1",
                    stepperDriver: "unknown",
                },
                {
                    diag: "C.3",
                    stepperDriver: "unknown",
                },
                {
                    diag: "C.0",
                    stepperDriver: "unknown",
                },
                {
                    diag: "C.2",
                    stepperDriver: "unknown",
                },
                {
                    diag: "A.0",
                    stepperDriver: "unknown",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'2',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: true,
                espDataReadyPin:'B.10',
                lpcTfrReadyPin:'B.11',
                espResetPin:'C.14',
                wifi8266CSPin: 'NoPin'
            },
            neopixel :'E.6',
            requiresRXTX: true
        },
        {
            name: 'fly_super8h7',
            requiresBoardTxt: true,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32H7',
            caption: 'Fly Super8 Pro H743',
            motorWarningCurrent: 1800,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 8,
            heaterPorts: ['bed', 'heat0','heat1','heat2','heat3','heat4'],
            fanPorts: ['fan0','fan1', 'fan2','fan3','fan4','fan5','fan6','fan7','fan8','fan9'],
            pwmPorts: ['bed', 'heat0','heat1','heat2','heat3','heat4','fan0','fan1', 'fan2','fan3','fan4','fan5','fan6','fan7','fan8','fan9'],
            gpioPorts: ['io0','io1','io2','io3','io4','io5','io6','io7','hvin','probe'],
            analogPorts: ['ADC_0','ADC_1','ADC_2','ADC_3','ADC_4','ADC_5'],
            blPorts: ['servo'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: true,
            hasESPOnboard: false,
            hasESP32Onboard: true,
            hasSBC: false,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32h7-wifi',
            firmwareSBCFile: '',
            firmwareWifiFile: 'DuetWiFiServer-esp32-stm32',
            firmwareWifi32File: 'DuetWiFiServer-esp32-stm32',
            firmwareNew: 'fly/firmware_super8pro_h743.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperOnboard: false,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '2',
            stepperDriver5160Pins: '',
            stepperDriver5160CS: [],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'D.13',
            lpcTfrReadyPin:'D.11',
            espResetPin:'D.10',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "E.9",
                    lcdBeepPin:     "C.5",
                    encoderPinA:    "E.7",
                    encoderPinB:    "B.2",
                    encoderPinSw:   "B.1",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 4, //Software SPI
                },
                diagnosticPin: "NoPin",
            },
            drives: [
                {
                    diag: "G.12",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.11",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.10",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.9",
                    stepperDriver: "unknown",
                },
                {
                    diag: "D.7",
                    stepperDriver: "unknown",
                },
                {
                    diag: "D.6",
                    stepperDriver: "unknown",
                },
                {
                    diag: "A.8",
                    stepperDriver: "unknown",
                },
                {
                    diag: "F.8",
                    stepperDriver: "unknown",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'2',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: true,
                espDataReadyPin:'D.13',
                lpcTfrReadyPin:'D.11',
                espResetPin:'D.10',
                wifi8266CSPin: 'NoPin'
            },
            neopixel :'NoPin',
            requiresRXTX: true
        },
        {
            name: 'fly_super8_pro_h723',
            requiresBoardTxt: true,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32H7',
            caption: 'Fly Super8 Pro H723',
            motorWarningCurrent: 1800,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 8,
            heaterPorts: ['bed', 'heat0','heat1','heat2','heat3','heat4'],
            fanPorts: ['fan0','fan1', 'fan2','fan3','fan4','fan5','fan6','fan7','fan8','fan9'],
            pwmPorts: ['bed', 'heat0','heat1','heat2','heat3','heat4','fan0','fan1', 'fan2','fan3','fan4','fan5','fan6','fan7','fan8','fan9'],
            gpioPorts: ['io0','io1','io2','io3','io4','io5','io6','io7','hvin','probe'],
            analogPorts: ['ADC_0','ADC_1','ADC_2','ADC_3','ADC_4','ADC_5'],
            blPorts: ['servo'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: true,
            hasESPOnboard: false,
            hasESP32Onboard: true,
            hasSBC: false,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32h723-wifi',
            firmwareSBCFile: '',
            firmwareWifiFile: 'DuetWiFiServer-esp32-stm32',
            firmwareWifi32File: 'DuetWiFiServer-esp32-stm32',
            firmwareNew: 'fly/firmware_super8pro_h723.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperOnboard: false,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '2',
            stepperDriver5160Pins: '',
            stepperDriver5160CS: [],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'D.13',
            lpcTfrReadyPin:'D.11',
            espResetPin:'D.10',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "E.9",
                    lcdBeepPin:     "C.5",
                    encoderPinA:    "E.7",
                    encoderPinB:    "B.2",
                    encoderPinSw:   "B.1",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 4, //Software SPI
                },
                diagnosticPin: "NoPin",
            },
            drives: [
                {
                    diag: "G.12",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.11",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.10",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.9",
                    stepperDriver: "unknown",
                },
                {
                    diag: "D.7",
                    stepperDriver: "unknown",
                },
                {
                    diag: "D.6",
                    stepperDriver: "unknown",
                },
                {
                    diag: "A.8",
                    stepperDriver: "unknown",
                },
                {
                    diag: "F.8",
                    stepperDriver: "unknown",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'2',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: true,
                espDataReadyPin:'D.13',
                lpcTfrReadyPin:'D.11',
                espResetPin:'D.10',
                wifi8266CSPin: 'NoPin'
            },
            neopixel :'NoPin',
            requiresRXTX: true
        },
        {
            name: 'biquskr_3_h723',
            requiresBoardTxt: true,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32H7',
            caption: 'BTT SKR3 H723',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 5,
            heaterPorts: ['bed', 'e0heat', 'e1heat'],
            fanPorts: ['fan0','fan1', 'fan2'],
            pwmPorts: ['bed', 'e0heat', 'e1heat','fan0','fan1', 'fan2','neopixel'],
            gpioPorts: ['xstop','ystop','zstop','probe','pson','e0stop', 'e1stop','pwrdet'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: true,
            hasESPOnboard: false,
            hasSBC: true,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32h723-wifi',
            firmwareSBCFile: '',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-stm32',
            firmwareWifi32File: 'DuetWiFiServer-esp32-stm32',
            firmwareNew: 'btt/firmware_skr3_h723.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperOnboard: false,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '3',
            stepperDriver5160Pins: '{ E.14, E.15, E.13 }',
            stepperDriver5160CS: [],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'B.10',
            lpcTfrReadyPin:'B.11',
            espResetPin:'C.14',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "E.9",
                    lcdBeepPin:     "C.5",
                    encoderPinA:    "E.7",
                    encoderPinB:    "B.2",
                    encoderPinSw:   "B.1",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 4, //Software SPI
                },
                diagnosticPin: "A.13",
            },
            drives: [
                {
                    diag: "C.1",
                    stepperDriver: "unknown",
                },
                {
                    diag: "C.3",
                    stepperDriver: "unknown",
                },
                {
                    diag: "C.0",
                    stepperDriver: "unknown",
                },
                {
                    diag: "C.2",
                    stepperDriver: "unknown",
                },
                {
                    diag: "A.0",
                    stepperDriver: "unknown",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'2',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: true,
                espDataReadyPin:'B.10',
                lpcTfrReadyPin:'B.11',
                espResetPin:'C.14',
                wifi8266CSPin: 'NoPin'
            },
            neopixel :'E.6',
            requiresRXTX: true
        },
        {
            name: 'biquskr_3_ez',
            requiresBoardTxt: true,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32H7',
            caption: 'BTT SKR3 EZ',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 5,
            heaterPorts: ['bed', 'e0heat', 'e1heat'],
            fanPorts: ['fan0','fan1', 'fan2'],
            pwmPorts: ['bed', 'e0heat', 'e1heat','fan0','fan1', 'fan2','neopixel'],
            gpioPorts: ['xstop','ystop','zstop','probe','pson','e0stop', 'e1stop','pwrdet'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: true,
            hasESPOnboard: false,
            hasSBC: true,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32h7-wifi',
            firmwareSBCFile: '',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-stm32',
            firmwareWifi32File: 'DuetWiFiServer-esp32-stm32',
            firmwareNew: 'btt/firmware_skr3ez_h743.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperOnboard: false,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '3',
            stepperDriver5160Pins: '{ E.14, E.15, E.13 }',
            stepperDriver5160CS: [],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'B.10',
            lpcTfrReadyPin:'B.11',
            espResetPin:'C.14',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "E.9",
                    lcdBeepPin:     "C.5",
                    encoderPinA:    "E.7",
                    encoderPinB:    "B.2",
                    encoderPinSw:   "B.1",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 4, //Software SPI
                },
                diagnosticPin: "A.13",
            },
            drives: [
                {
                    diag: "C.1",
                    stepperDriver: "unknown",
                },
                {
                    diag: "C.3",
                    stepperDriver: "unknown",
                },
                {
                    diag: "C.0",
                    stepperDriver: "unknown",
                },
                {
                    diag: "C.2",
                    stepperDriver: "unknown",
                },
                {
                    diag: "A.0",
                    stepperDriver: "unknown",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'2',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: true,
                espDataReadyPin:'B.10',
                lpcTfrReadyPin:'B.11',
                espResetPin:'C.14',
                wifi8266CSPin: 'NoPin'
            },
            neopixel :'E.6',
            requiresRXTX: true
        },
        {
            name: 'fly_e3_v2',
            requiresBoardTxt: true,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32F4',
            caption: 'Fly-E3-v2',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 5,
            heaterPorts: ['bed', 'e0heat', 'e1heat'],
            fanPorts: ['fan0','fan1', 'fan2', 'fan3'],
            pwmPorts: ['bed', 'e0heat', 'e1heat','fan0','fan1', 'fan2', 'fan3'],
            gpioPorts: ['xstop','ystop','zstop', 'probe'],
            analogPorts: ['bedtemp', 'e0temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: true,
            hasESPOnboard: false,
            hasESP32Onboard: true,
            hasSBC: false,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32f4-wifi',
            firmwareSBCFile: 'firmware-stm32f4-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-stm32',
            firmwareNew: 'fly/firmware_e3_2_f4.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            firmwareWifi32File: 'N/A',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperOnboard: false,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '2',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'E.10',
            lpcTfrReadyPin:'E.12',
            espResetPin:'E.11',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "NoPin",
                    lcdBeepPin:     "NoPin",
                    encoderPinA:    "NoPin",
                    encoderPinB:    "NoPin",
                    encoderPinSw:   "NoPin",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "A.15",
            },
            drives: [
                {
                    diag: "E.7",
                    stepperDriver: "unknown",
                },
                {
                    diag: "E.8",
                    stepperDriver: "unknown",
                },
                {
                    diag: "E.9",
                    stepperDriver: "unknown",
                },
                {
                    diag: "",
                    stepperDriver: "unknown",
                },
                {
                    diag: "",
                    stepperDriver: "unknown",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'2',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: true,
                espDataReadyPin:'E.10',
                lpcTfrReadyPin:'E.12',
                espResetPin:'E.11',
                wifi8266CSPin: 'NoPin'
            },
            neopixel :'NoPin',
            requiresRXTX: true
        },
        {
            name: 'fly_super5_h723',
            requiresBoardTxt: true,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32H7',
            caption: 'Fly Super5 Pro H723',
            motorWarningCurrent: 1800,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 8,
            heaterPorts: ['bed', 'heat0','heat1'],
            fanPorts: ['fan0','fan1', 'fan2','fan3'],
            pwmPorts: ['bed', 'heat0','heat1','heat2','fan0','fan1', 'fan2','fan3'],
            gpioPorts: ['io0','io1','io2','io3','io4','io5','probe'],
            analogPorts: ['ADC0','ADC1','ADC2'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: true,
            hasESPOnboard: false,
            hasESP32Onboard: true,
            hasSBC: false,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32h723-wifi',
            firmwareSBCFile: '',
            firmwareWifiFile: 'DuetWiFiServer-esp32-stm32',
            firmwareWifi32File: 'DuetWiFiServer-esp32-stm32',
            firmwareNew: 'fly/firmware_super5_h723.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperOnboard: false,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '0',
            stepperDriver5160Pins: '',
            stepperDriver5160CS: [],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'D.10',
            lpcTfrReadyPin:'D.11',
            espResetPin:'D.14',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "E.9",
                    lcdBeepPin:     "C.5",
                    encoderPinA:    "E.7",
                    encoderPinB:    "B.2",
                    encoderPinSw:   "B.1",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 4, //Software SPI
                },
                diagnosticPin: "NoPin",
            },
            drives: [
                {
                    diag: "B.7",
                    stepperDriver: "unknown",
                },
                {
                    diag: "C.7",
                    stepperDriver: "unknown",
                },
                {
                    diag: "C.6",
                    stepperDriver: "unknown",
                },
                {
                    diag: "C.13",
                    stepperDriver: "unknown",
                },
                {
                    diag: "C.14",
                    stepperDriver: "unknown",
                },
                {
                    diag: "C.15",
                    stepperDriver: "unknown",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'2',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: true,
                espDataReadyPin:'D.10',
                lpcTfrReadyPin:'D.11',
                espResetPin:'D.14',
                wifi8266CSPin: 'NoPin'
            },
            neopixel :'B.2',
            requiresRXTX: true
        },
        {
            name: 'btt_kraken',
            requiresBoardTxt: true,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32H7',
            caption: 'BTT Kraken',
            motorWarningCurrent: 8000,
            motorLimitCurrent: 10000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 8,
            heaterPorts: ['bed', 'e0heat', 'e1heat','e2heat'],
            fanPorts: ['fan0','fan1','fan2'],
            pwmPorts: ['bed', 'e0heat', 'e1heat','e2heat','fan0','fan1','fan2'],
            gpioPorts: ['xstop','ystop','zstop', 'e0stop','e1stop','e2stop','probe'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp','e2temp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: false,
            hasESPOnboard: false,
            hasSBC: true,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32f4-wifi',
            firmwareSBCFile: 'firmware-stm32f4-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-stm32',
            firmwareWifi32File: 'DuetWiFiServer-esp32-stm32',
            firmwareNew: 'btt/firmware_kraken_h723.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: ['BTT EXP-MOT'],
            maxExpansionBoards: 1,
            stepperOnboard: true,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '2',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [
                {
                    diag: "A.15",
                },
                {
                    diag: "B.8",
                },
                {
                    diag: "B.9",
                },
                {
                    diag: "B.3",
                },
                {
                    diag: "G.15",
                },
                {
                    diag: "G.12",
                }
            ],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'A.8',
            lpcTfrReadyPin:'G.4',
            espResetPin:'F.12',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "NoPin",
                    lcdBeepPin:     "NoPin",
                    encoderPinA:    "NoPin",
                    encoderPinB:    "NoPin",
                    encoderPinSw:   "NoPin",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "A.7",
            },
            drives: [
                {
                diag: "B.10",
                stepperDriver: "TMC5160",
                },
                {
                diag: "E.12",
                stepperDriver: "TMC5160",
                },
                {
                diag: "G.8",
                stepperDriver: "TMC5160",
                },
                {
                diag: "E.15",
                stepperDriver: "TMC5160",
                },
                {
                diag: "E.10",
                stepperDriver: "TMC5160",
                },
                {
                diag: "G.5",
                stepperDriver: "TMC5160",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'3',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: true,
                espDataReadyPin:'G.10',
                lpcTfrReadyPin:'F.11',
                espResetPin:'F.12',
                wifi8266CSPin: 'B.12'
            },
            neopixel :'NoPin',
            requiresRXTX: true
        },
        {
            name: 'fly_e3_ultra',
            requiresBoardTxt: false,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32H7',
            caption: 'Fly-E3-Ultra',
            motorWarningCurrent: 1200,
            motorLimitCurrent: 2000,
            seriesResistor: 2200,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 5,
            heaterPorts: ['bed', 'e0heat', 'e1heat'],
            fanPorts: ['fan0','fan1', 'fan2', 'fan3'],
            pwmPorts: ['bed', 'e0heat', 'e1heat','fan0','fan1', 'fan2', 'fan3','neopixel', 'laser'],
            gpioPorts: ['xstop','ystop','zstop','probe','pson','pwrdet'],
            analogPorts: ['bedtemp', 'e0temp', 'e1temp', 'boardtemp'],
            blPorts: ['servo0'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: true,
            hasESPOnboard: false,
            hasESP32Onboard: true,
            hasSBC: false,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32f4-wifi',
            firmwareSBCFile: 'firmware-stm32f4-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp32-stm32',
            firmwareWifi32File: 'N/A',
            firmwareNew: 'fly/firmware_e3ultra_h723.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperOnboard: true,
            stepperDriver: "TMC2209",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: false,
            stepperDriver5160SPI: 'N/A',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'E.13',
            lpcTfrReadyPin:'E.14',
            espResetPin:'E.15',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "NoPin",
                    lcdBeepPin:     "NoPin",
                    encoderPinA:    "NoPin",
                    encoderPinB:    "NoPin",
                    encoderPinSw:   "NoPin",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "NoPin",
            },
            drives: [
                {
                    diag: "D.12",
                    stepperDriver: "TMC2209",
                },
                {
                    diag: "B.10",
                    stepperDriver: "TMC2209",
                },
                {
                    diag: "C.4",
                    stepperDriver: "TMC2209",
                },
                {
                    diag: "NoPin",
                    stepperDriver: "TMC2209",
                },
                {
                    diag: "NoPin",
                    stepperDriver: "TMC2209",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'2',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: true,
                espDataReadyPin:'E.13',
                lpcTfrReadyPin:'E.14',
                espResetPin:'E.15',
                wifi8266CSPin: 'NoPin'
            },
            neopixel :'B.11',
            requiresRXTX: true
        },
        {
            name: 'fly_prox10_h723',
            requiresBoardTxt: true,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32H7',
            caption: 'Fly ProX10 H723',
            motorWarningCurrent: 1800,
            motorLimitCurrent: 2000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 8,
            heaterPorts: ['bed', 'heat0','heat1','heat2','heat3','heat4'],
            fanPorts: ['fan0','fan1', 'fan2','fan3','fan4','fan5','fan6','fan7'],
            pwmPorts: ['bed', 'heat0','heat1','heat2','heat3','heat4','fan0','fan1', 'fan2','fan3','fan4','fan5','fan6','fan7'],
            gpioPorts: ['io0','io1','io2','io3','io4','io5','io6','hvin','probe'],
            analogPorts: ['ADC0','ADC1','ADC2','ADC3','ADC4','ADC5'],
            blPorts: ['servo'],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: true,
            hasESPOnboard: false,
            hasESP32Onboard: true,
            hasSBC: false,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32h723-wifi',
            firmwareSBCFile: '',
            firmwareWifiFile: 'DuetWiFiServer-esp32-stm32',
            firmwareWifi32File: 'DuetWiFiServer-esp32-stm32',
            firmwareNew: 'fly/firmware_prox10_h723.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperOnboard: false,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '0',
            stepperDriver5160Pins: '',
            stepperDriver5160CS: [],
            serialRxPin:'D.9',
            serialTxPin:'D.8',
            espDataReadyPin:'D.13',
            lpcTfrReadyPin:'D.11',
            espResetPin:'D.10',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "E.9",
                    lcdBeepPin:     "C.5",
                    encoderPinA:    "E.7",
                    encoderPinB:    "B.2",
                    encoderPinSw:   "B.1",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 4, //Software SPI
                },
                diagnosticPin: "NoPin",
            },
            drives: [
                {
                    diag: "G.8",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.7",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.6",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.5",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.4",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.3",
                    stepperDriver: "unknown",
                },
                {
                    diag: "G.2",
                    stepperDriver: "unknown",
                },
                {
                    diag: "B.1",
                    stepperDriver: "unknown",
                },
                {
                    diag: "F.9",
                    stepperDriver: "unknown",
                },
                {
                    diag: "C.6",
                    stepperDriver: "unknown",
                }
            ],
            auxRX:'A.10',
            auxTX:'A.9',
            serialAmount:'2',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: true,
                espDataReadyPin:'D.13',
                lpcTfrReadyPin:'D.11',
                espResetPin:'D.10',
                wifi8266CSPin: 'NoPin'
            },
            neopixel :'NoPin',
            requiresRXTX: true
        },
        {
            name: 'btt_scylla_v1',
            requiresBoardTxt: true,
            unknownWifi: false,
            needWifiSerial: false,
            type: 'STM32H7',
            caption: 'BTT Scylla V1',
            motorWarningCurrent: 8000,
            motorLimitCurrent: 10000,
            seriesResistor: 4700,
            microstepping: true,
            microsteppingInterpolation: true,
            numDrives: 8,
            heaterPorts: [],
            fanPorts: [],
            pwmPorts: ['aux0', 'aux1', 'aux2','coolant','mist'],
            gpioPorts: ['xmin','xmax','ymin','ymax','zmin','zmax','amin','amax', 'extin0','relay','tool','probe'],
            analogPorts: [],
            blPorts: [],
            spiCsPorts: [],
            hasEthernet: false,
            hasWiFi: false,
            hasESP: true,
            hasESPUpdate: false,
            hasESPOnboard: false,
            hasSBC: true,
            hasSBCOnboard: false,
            hasPowerFailureDetection: false,
            hasMotorLoadDetection: true,
            supportsDisplay: true,
            supports12864: false,
            firmwareStandaloneFile: 'firmware-stm32f4-wifi',
            firmwareSBCFile: 'firmware-stm32f4-sbc',
            firmwareWifiFile: 'DuetWiFiServer-esp8266-stm32',
            firmwareWifi32File: 'DuetWiFiServer-esp32-stm32',
            firmwareNew: 'btt/firmware_scylla1_0_h723.bin',
            firmwareWifi32FileNew: 'WiFiModule_esp32.bin',
            firmwareWifiFileNew: 'WiFiModule_esp8266.bin',
            requiresBeta: false,
            iapFile: '',
            expansionBoards: [],
            maxExpansionBoards: 0,
            stepperOnboard: true,
            stepperDriver: "",
            stepperDriverTimings: "",
            stepperDriverSmart: true,
            stepperDriver5160: true,
            stepperDriver5160SPI: '2',
            stepperDriver5160Pins: 'N/A',
            stepperDriver5160CS: [
                {
                    diag: "C.1",
                },
                {
                    diag: "C.3",
                },
                {
                    diag: "E.3",
                },
                {
                    diag: "E.0",
                }
            ],
            serialRxPin:'A.3',
            serialTxPin:'A.2',
            espDataReadyPin:'E.9',
            lpcTfrReadyPin:'E.8',
            espResetPin:'E.10',
            lpc: {
                externalSDCard:{
                    csPin: "NoPin",
                    cardDetectPin: "NoPin",
                    spiFrequencyHz: 4000000,
                    spiChannel: 0,
                },
                internalSDCardSPIFrequencyHz: 25000000,
                softwareSPI:{
                    pins: ["NoPin", "NoPin", "NoPin"],
                },
                lcd:{
                    lcdCSPin:       "NoPin",
                    lcdBeepPin:     "NoPin",
                    encoderPinA:    "NoPin",
                    encoderPinB:    "NoPin",
                    encoderPinSw:   "NoPin",
                    lcdDCPin:       "NoPin",
                    panelButtonPin: "NoPin",
                    spiChannel: 2, //Software SPI
                },
                diagnosticPin: "NoPin",
            },
            drives: [
                {
                diag: "C.1",
                stepperDriver: "TMC5160",
                },
                {
                diag: "C.3",
                stepperDriver: "TMC5160",
                },
                {
                diag: "E.3",
                stepperDriver: "TMC5160",
                },
                {
                diag: "E.0",
                stepperDriver: "TMC5160",
                }
            ],
            auxRX:'D.9',
            auxTX:'D.8',
            serialAmount:'3',
            wifi8266CSPin: 'NoPin',
            esp32: {
                esp32Supported: true,
                espDataReadyPin:'E.9',
                lpcTfrReadyPin:'E.8',
                espResetPin:'E.10',
                wifi8266CSPin: 'E.11'
            },
            neopixel :'NoPin',
            requiresRXTX: true
        },
	],

	getBoard(boardType) {
		const boardDefinitions = this.getBoards();
		for (let i in boardDefinitions) {
			if (boardDefinitions[i].name == boardType) {
				return boardDefinitions[i];
			}
		}
		throw 'Invalid board';
	},

	isValidPin(board, pin, canAddress) {
		const pinTypes = ['heaterPorts', 'fanPorts', 'pwmPorts', 'gpioPorts', 'analogPorts', 'spiCsPorts', 'blPorts'];
		return pinTypes.some(function(pinType) {
			return board[pinType].some(function(boardPort) {
				return ((!canAddress && Template.isSamePin(pin, boardPort)) ||
						(canAddress !== undefined && Template.isSamePin(pin, `${canAddress}.${boardPort}`)));
			});
		});
	}
}
